import type { AttendeeView } from '@/lib/recordings/types/attendees';
import { displayNameFor } from './attendee-display';

/**
 * The single letter an attendee's avatar shows.
 *
 * One letter, not two: `Avatar.Group` overlaps each circle by 60% of its
 * width, so a second glyph is covered by the next avatar and "MR" reads as
 * "MF". Falls through to `?` rather than an empty circle — a nameless
 * attendee is still a person in the room.
 */
export function attendeeInitial(attendee: AttendeeView): string {
  const name = displayNameFor(attendee);
  // When the name IS the email, only its local part identifies the person —
  // taking the first letter anywhere would give everyone at one domain the
  // same initial.
  const identifying = name === attendee.email ? name.split('@')[0] : name;
  // Skip quotes, punctuation and digits: an avatar reading "." names nobody.
  for (const char of identifying) {
    if (/\p{L}/u.test(char)) return char.toUpperCase();
  }
  return '?';
}
